import { createSlice } from '@reduxjs/toolkit'
import HeaderAlertModel from "./HeaderAlertModel";

const initialState: HeaderAlertModel = {
    type: '',
    text: '',
    show: false,
    timeoutSeconds: 0
}
export const counterSlice = createSlice({
    name: 'alerts',
    initialState,
    reducers: {
        reducerAppAlert: (state, action) => {
            state.type = action.payload.type
            state.text = action.payload.text
            state.show = action.payload.show
            state.timeoutSeconds = action.payload.timeoutSeconds
        },
        reducerAlertClose: (state) => {
            state.show = false
        },
    },
})

export const { reducerAppAlert, reducerAlertClose } = counterSlice.actions
export default counterSlice.reducer

/*
const headerAlertReducer = (state = initialState, action: any) => {
    if (action.type === APP_ALERT) {
        return {
            ...state,
            type: action.payload.type,
            text: action.payload.text,
            show: action.payload.show,
            timeoutSeconds: action.payload.timeoutSeconds
        }
    }
    return state;
}
export default headerAlertReducer;

*/

